import { render, staticRenderFns } from "./IngredientForm.vue?vue&type=template&id=7e871ea4&scoped=true"
import script from "./IngredientForm.vue?vue&type=script&lang=js"
export * from "./IngredientForm.vue?vue&type=script&lang=js"
import style0 from "./IngredientForm.vue?vue&type=style&index=0&id=7e871ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e871ea4",
  null
  
)

export default component.exports